import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ConfigModel} from '../../shared/model/config.model';

@Component({
    selector: 'app-evaluetion-form-modal',
    templateUrl: './evaluetion-form-modal.component.html',
    styleUrls: ['./evaluetion-form-modal.component.css']
})
export class EvaluetionFormModalComponent implements OnInit {
    @Output() save = new EventEmitter<ConfigModel>();

    display: boolean;
    evaluetion: ConfigModel = new ConfigModel();

    constructor() {
    }

    ngOnInit() {
        this.evaluetion.value = '';
    }


    saveEvaluetion() {
        this.save.emit(this.evaluetion);
    }

    onCloseModal() {
        //this.question = new QuestionModel();
    }

    validate() {
        return true;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/config/evaluetion-form-modal/evaluetion-form-modal.component.ts